import React from 'react';
import CloseIcon from '../../assets/svg/closeIcon';

function ApproxTimePopup({
    setShowSecondPopup,
    deliveryOffsetMinutes,
    setDeliveryOffsetMinutes,
}) {
    const decreaseTime = () => {
        if (deliveryOffsetMinutes > 0) {
            setDeliveryOffsetMinutes(deliveryOffsetMinutes - 1);
        }
    };

    const increaseTime = () => {
        setDeliveryOffsetMinutes(deliveryOffsetMinutes + 1);
    };

    const handleSetTime = () => {
        setShowSecondPopup(false);
    };

    const handleClose = () => {
        setShowSecondPopup(false);
    };

    return (
        <div className="second-popup-container">
            <div className="second-popup">
                <div className="approx-time-header">
                    <div></div>
                    <h6 className="second-popup-heading">Set approx time</h6>
                    <CloseIcon
                        size={30}
                        color='black'
                        onClick={handleClose}
                        className='close-icon'
                    />
                </div>
                <div className="second-popup-btns-container2">
                    <button
                        className="second-popup-minus-plus-btn"
                        onClick={decreaseTime}
                    >
                        -
                    </button>
                    <button className="second-popup-time-btn">
                        {deliveryOffsetMinutes} min
                    </button>
                    <button
                        className="second-popup-minus-plus-btn"
                        onClick={increaseTime}
                    >
                        +
                    </button>
                </div>
                <button
                    className="second-popup-settime-btn"
                    onClick={handleSetTime}
                >
                    Set time
                </button>
            </div>
            <div className="new-orders-blur-background"></div>
        </div>
    );
}

export default ApproxTimePopup;
